import { Controller } from '@hotwired/stimulus'

export default class PublishGateController extends Controller<HTMLElement> {
  static targets = ['button']

  static values = {
    blocked: Boolean
  }

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly blockedValue: boolean

  connect (): void {
    this.buttonTarget.disabled = this.blockedValue
  }
}
